import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import Session, { game_type } from "../../Session";
import ConfettiAnim from "../ConfettiAnim";
import { Profile } from "../../lib/game_snacks/IUser";
import LobbyBigButton, { lobby_big_button_type } from "../LobbyBigButton";
import GSAvatarLoader from "../../lib/GSAvatarLoader";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class RoundOverPopup extends Popup
{
    // #region Attributes //

    // private:

    private _playerIndex: number = null;
    private _isGameOver: boolean = null;
    private _round: number = null;
    private _arrRoundScore: Array<number> = null;
    private _arrLastScore: Array<number> = null;

    private _backLayer: PIXI.Container = null;
    private _frontLayer: PIXI.Container = null;
    
    private _playBtn: Button = null;

    private _arrLeadRow: Array<PIXI.Container> = null;

    private _confettiAnim: ConfettiAnim = null;
    
    private _leadChangeTl: gsap.core.Timeline = null;

    // #endregion //


    public set playerIndex( value: number ) { this._playerIndex = value; }
    public set isGameOver( value: boolean ) { this._isGameOver = value; }
    public set round( value: number ) { this._round = value; }
    public set roundScores( value: Array<number> ) { this._arrRoundScore = value; }
    public set lastScores( value: Array<number> ) { this._arrLastScore = value; }


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        console.assert( this._playerIndex !== null, "RoundOverPopup.ts :: onEnter() :: this._playerIndex cannot be null." );
        console.assert( this._isGameOver !== null, "RoundOverPopup.ts :: onEnter() :: this._isGameOver cannot be null." );
        console.assert( this._arrRoundScore !== null, "RoundOverPopup.ts :: onEnter() :: this._arrRoundScore cannot be null." );
        console.assert( this._arrLastScore !== null, "RoundOverPopup.ts :: onEnter() :: this._arrLastScore cannot be null." );

        this._disabledBg.visible = false;

        this._arrLeadRow = [];
        let playerIndexToLeadRow: Map<number, PIXI.Container> = new Map<number, PIXI.Container>();
        let leadRowToPlayerIndex: Map<PIXI.Container, number> = new Map<PIXI.Container, number>();

        this._backLayer = new PIXI.Container();
        this._root.addChild( this._backLayer );
        //
        this._frontLayer = new PIXI.Container();
        this._root.addChild( this._frontLayer );

        let disabledBg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.tut_bg.texture );
        disabledBg.interactive = true;
        disabledBg.anchor.set( 0.5 );
        disabledBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._backLayer.addChild( disabledBg );

        if ( this._isGameOver )
        {
            let godrays: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.godrays.texture );
            godrays.blendMode = PIXI.BLEND_MODES.ADD;
            godrays.alpha = 0.4;
            godrays.anchor.set( 0.5 );
            godrays.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
            this._backLayer.addChild( godrays );

            this._confettiAnim = new ConfettiAnim();
            this._confettiAnim.init();
            this._backLayer.addChild( this._confettiAnim );
        }

        let arrLeaderboardPlayerIndex: Array<number> = [];
        let arrFinalLeaderboardPlayerIndex: Array<number> = [];
        for ( let i: number = 0; i < Session.i.room.length; ++i )
        {
            if ( arrLeaderboardPlayerIndex.length == 0 )
            {
                arrLeaderboardPlayerIndex.push( i );
            }
            else
            {
                let isInsert: boolean = false;
                for ( let j: number = 0; j < Session.i.room.length; ++j )
                {
                    if ( this._arrLastScore[ arrLeaderboardPlayerIndex[ j ] ] > this._arrLastScore[ i ] )
                    {
                        arrLeaderboardPlayerIndex.splice( j, 0, i );

                        isInsert = true;
                        break;
                    }
                }

                if ( !isInsert )
                {
                    arrLeaderboardPlayerIndex.push( i );
                }
            }

            if ( arrFinalLeaderboardPlayerIndex.length == 0 )
            {
                arrFinalLeaderboardPlayerIndex.push( i );
            }
            else
            {
                let isInsert: boolean = false;
                for ( let j: number = 0; j < Session.i.room.length; ++j )
                {
                    if ( this._arrLastScore[ arrFinalLeaderboardPlayerIndex[ j ] ] + this._arrRoundScore[ arrFinalLeaderboardPlayerIndex[ j ] ] > this._arrLastScore[ i ] + this._arrRoundScore[ i ] )
                    {
                        arrFinalLeaderboardPlayerIndex.splice( j, 0, i );

                        isInsert = true;
                        break;
                    }
                }

                if ( !isInsert )
                {
                    arrFinalLeaderboardPlayerIndex.push( i );
                }
            }
        }

        let playerRank: number = 1;
        for ( let playerIndex of arrFinalLeaderboardPlayerIndex )
        {
            if ( Session.i.room[ playerIndex ].uid == Session.i.profile.uid )
            {
                break;
            }

            playerRank += 1;
        }

        if ( playerRank == 1 
            && this._isGameOver
            && Session.i.gameType == game_type.MATCHMAKING )
        {
            ServiceLocator.saved.data.score += 1;
            ServiceLocator.saved.save();

            window.GameSnacks.score.update( ServiceLocator.saved.data.score );
        }

        let banner: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.tut_header_base.texture );
        banner.name = "banner";
        banner.anchor.set( 0.5 );
        banner.position.set( ServiceLocator.app.width * 0.5, 136 );
        this._frontLayer.addChild( banner );
        //
        let subtitle: PIXI.Text = null;
        if ( this._isGameOver )
        {
            let title: PIXI.Text = new PIXI.Text( this._round === null ? "GAME OVER" : "FINAL RESULT", { fontFamily: "asap_extrabold", fontSize: 70, fill: 0xffd21f } );
            title.anchor.set( 0.5, 1 );
            title.y += 20;
            banner.addChild( title );

            subtitle = new PIXI.Text( "You came...", { fontFamily: "asap_extrabold", fontSize: 40, fill: 0xffffe0 } );
            subtitle.anchor.set( 0.5, 0 );
            subtitle.y += 8;
            banner.addChild( subtitle );
        }
        else
        {
            let title: PIXI.Text = new PIXI.Text( "ROUND " + this._round.toString(), { fontFamily: "asap_extrabold", fontSize: 58, fill: 0xffffe0 } );
            title.anchor.set( 0.5 );
            banner.addChild( title );
        }

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ this._isGameOver ? "results_final_base" : "results_round_base" ].texture );
        base.name = "base";
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 + 40 );
        this._frontLayer.addChild( base );

        let playerRowBg: PIXI.Sprite = new PIXI.Sprite();
        this._updatePlayerRowBg( arrLeaderboardPlayerIndex.indexOf( this._playerIndex ), playerRowBg );
        base.addChild( playerRowBg );

        /*let winnerRowBg: PIXI.Sprite = null;
        if ( this._isGameOver )
        {
            winnerRowBg = new PIXI.Sprite( ServiceLocator.resources.results_winner_row.texture );
            winnerRowBg.alpha = 0;
            base.addChild( winnerRowBg );
        }*/
        
        let rowY: number = ( this._isGameOver ? 68 : 47 ) + 127 - 50;
        const kRowX: number = this._isGameOver ? 54 : 42;
        let badge: PIXI.Sprite = null;
        let arrRankItem: Array<PIXI.DisplayObject> = [];
        for ( let i: number = 0; i < Session.i.room.length; ++i )
        {
            const kPlayerIndex: number = arrLeaderboardPlayerIndex[ i ];

            if ( i == 0 )
            {
                badge = new PIXI.Sprite( ServiceLocator.resources[ "badge_1st_" + ( this._isGameOver ? "final" : "round" ) ].texture );
                badge.anchor.set( 0, 0.5 );
                badge.position.set( kRowX, rowY - 20 );
                if ( this._isGameOver )
                {
                    badge.position.set( kRowX - 10, rowY - 20 );
                }
                else
                {
                    badge.position.set( kRowX - 18, rowY - 14 );
                }
                base.addChild( badge );

                arrRankItem.push( badge );
            }
            /*else
            {*/
                let rankText: PIXI.Text = new PIXI.Text( ( i + 1 ).toString() + [ "st", "nd", "rd", "th" ][ i ], { fontFamily: "asap_bold", fontSize: ( i == 0 ? 48 : 38 ), fill: 0x474747 } );
                rankText.anchor.set( 0, 0.5 );
                rankText.position.set( kRowX + 4, rowY - 14 );
                base.addChild( rankText );

                arrRankItem.push( rankText );
            //}

            let row: PIXI.Container = new PIXI.Container();
            row.position.set( kRowX, rowY );
            base.addChild( row );
            this._arrLeadRow.push( row );
            //
            playerIndexToLeadRow.set( kPlayerIndex, row );
            leadRowToPlayerIndex.set( row, kPlayerIndex );

            let portrait: PIXI.Sprite = new PIXI.Sprite();
            portrait.anchor.set( 0, 1 );
            const kPortraitWidth: number = 96;
            GSAvatarLoader.i.load( 
                Session.i.room[ kPlayerIndex ].avatar.src, 
                ( texture: PIXI.Texture ) => {
                    try
                    {
                        portrait.texture = texture;
                        portrait.scale.set( kPortraitWidth / portrait.texture.width ); 
                    }
                    catch( ex ) {}
                } );
            portrait.position.set( 75, 34 );
            row.addChild( portrait );
            
            let usernameText: PIXI.Text = new PIXI.Text( Session.i.room[ kPlayerIndex ].username.prefix, { fontFamily: "asap_extrabold", fontSize: 38, fill: 0x474747 } );
            usernameText.anchor.set( 0, 0.5 );
            Utils.fitTextToWidth( usernameText, 152 );
            usernameText.position.set( 180, -14 );
            row.addChild( usernameText );

            let roundPointText: PIXI.Text = new PIXI.Text( "+" + this._arrRoundScore[ kPlayerIndex ].toString(), { fontFamily: "asap_bold", fontSize: 32, fill: 0x474747 } );
            roundPointText.anchor.set( 0.5 );
            roundPointText.visible = false;
            Utils.fitTextToWidth( roundPointText, 446 - 10 - 350 );
            roundPointText.position.set( 350 + roundPointText.width * 0.5, usernameText.y );
            row.addChild( roundPointText );

            let totalPointsText: PIXI.Text = new PIXI.Text( this._arrLastScore[ kPlayerIndex ].toString(), { fontFamily: "asap_extrabold", fontSize: 48, fill: 0x474747 } );
            totalPointsText.anchor.set( 0.5 );
            Utils.fitTextToWidth( totalPointsText, 520 - 446 );
            totalPointsText.position.set( 446 + totalPointsText.width * 0.5, usernameText.y );
            row.addChild( totalPointsText );

            rowY += 127;
        }

        if ( this._isGameOver )
        {
            base.addChild( badge );
        }

        let gameOverConditionText: PIXI.Text = new PIXI.Text( this._isGameOver ? "One More Game?" : "First to 200 points loses", { fontFamily: "asap_bold", fontSize: 30, fill: 0x474747, stroke: 0xffffff } );
        gameOverConditionText.anchor.set( 0.5 );
        gameOverConditionText.position.set( base.texture.width * 0.5, base.texture.height - 90 );
        base.addChild( gameOverConditionText );

        let arrButton: Array<Button> = [];
        if ( !this._isGameOver )
        {
            let continueBtn: Button = new Button( { on: "tut_button_continue", pressed: "tut_button_continue_pressed" } );
            continueBtn.anchor.set( 0.5 );
            continueBtn.position.set( ServiceLocator.app.width * 0.5, 1052 );
            this._frontLayer.addChild( continueBtn );
            continueBtn.on( "pointertap", this.onContinueBtn_Click, this );
            //
            arrButton.push( continueBtn );
        }
        else
        {
            let homeBtn: Button = new Button( { on: "button_home", pressed: "button_home_pressed" } );
            homeBtn.name = "homeBtn";
            homeBtn.anchor.set( 0.5 );
            homeBtn.position.set( 243, 1052 );
            this._frontLayer.addChild( homeBtn );
            homeBtn.on( "pointertap", this.onContinueBtn_Click, this );
            //
            arrButton.push( homeBtn );

            this._playBtn = new Button( { on: "button_replay", pressed: "button_replay_pressed" } );
            this._playBtn.name = "playBtn";
            this._playBtn.anchor.set( 0.5 );
            this._playBtn.position.set( 397, homeBtn.y );
            this._frontLayer.addChild( this._playBtn );
            this._playBtn.on( "pointertap", this.onPlayBtn_Click, this );
            //
            arrButton.push( this._playBtn );

            if ( ServiceLocator.saved.data.isFirstGame )
            {
                homeBtn.x = ServiceLocator.app.width * 0.5;
                this._playBtn.visible = false;
                gameOverConditionText.visible = false;
            }
        }

        for ( let button of arrButton )
        {
            button.setEnabled( false );
        }

        if ( this._round === 1 )
        {
            for ( let rankItem of arrRankItem )
            {
                rankItem.visible = false;
            }
        }

        this._leadChangeTl = new gsap.core.Timeline();
        this._leadChangeTl.delay( 0.4 );
        let tallingPointsSfx: Howl = null;
        for ( let row of this._arrLeadRow )
        {
            this._leadChangeTl.call( () => { row.children[ 2 ].visible = true; }, null );
            this._leadChangeTl.from( row.children[ 2 ].scale, { x: 2, y: 2, duration: 0.4, ease: "back.out" } );
            this._leadChangeTl.call( () => { 
                tallingPointsSfx = ServiceLocator.audio.playSfx( "talling_points", { loop: true } ); 
            } );
            let dummyScore: any = { x: this._arrLastScore[ leadRowToPlayerIndex.get( row ) ] };
            const kFinalScore: number = this._arrLastScore[ leadRowToPlayerIndex.get( row ) ] + this._arrRoundScore[ leadRowToPlayerIndex.get( row ) ];
            this._leadChangeTl.to( dummyScore, { x: kFinalScore, duration: this._arrRoundScore[ leadRowToPlayerIndex.get( row ) ] / 100, ease: "linear.inOut", 
                onUpdate: () => { 
                    let finalScoreText: PIXI.Text = row.children[ 3 ] as PIXI.Text;
                    finalScoreText.text = Math.round( dummyScore.x ).toString(); 
                    Utils.fitTextToWidth( finalScoreText, 520 - 446 );
                    finalScoreText.x = 446 + finalScoreText.width * 0.5;
                },
                onComplete: () => {
                    if ( tallingPointsSfx )
                    {
                        if ( kFinalScore >= 200 )
                        {
                            let eliminatedStamp: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.eliminated_stamp.texture );
                            eliminatedStamp.anchor.set( 0.5, 0 );
                            eliminatedStamp.position.set( 75 + 50, -8 );
                            row.addChild( eliminatedStamp );

                            ( row.children[ 3 ] as PIXI.Text ).style.fill = 0xff0000;
                        }

                        ServiceLocator.audio.stopSfx( "talling_points" );
                        tallingPointsSfx = null;
                    }
                }
            } );
        }
        //
        this._leadChangeTl.call( () => { playerRowBg.visible = false; }, null, "+=0.4" );
        //
        let rowIndex: number = 0;
        for ( let playerIndex of arrLeaderboardPlayerIndex )
        {
            let finalRowIndex: number = 0;
            while ( finalRowIndex < arrFinalLeaderboardPlayerIndex.length )
            {
                if ( arrFinalLeaderboardPlayerIndex[ finalRowIndex ] == playerIndex )
                {
                    break;
                }

                finalRowIndex += 1;
            }

            if ( rowIndex != finalRowIndex )
            {
                this._leadChangeTl.to( this._arrLeadRow[ rowIndex ], { y: ( this._isGameOver ? 68 : 47 ) + 127 - 50 + 127 * finalRowIndex, duration: 0.4, ease: "sine.out" }, "<" );
            }

            rowIndex += 1;
        }
        if ( this._isGameOver )
        {
            this._leadChangeTl.call( () => { 
                ServiceLocator.audio.playSfx( "final_result" );

                subtitle.text = "You came in " + playerRank.toString() + [ "st", "nd", "rd", "th" ][ playerRank - 1 ] + " place!";

                let crown: PIXI.Sprite = this._addCrown( playerIndexToLeadRow.get( arrFinalLeaderboardPlayerIndex[ 0 ] ).children[ 0 ] as PIXI.Sprite );
                //
                this._leadChangeTl.from( crown, { y: "-=40", duration: 0.4, ease: "sine.out" }, this._leadChangeTl.time() );
                this._leadChangeTl.from( crown, { alpha: 0, duration: 0.2, ease: "sine.in" }, this._leadChangeTl.time() );
            } );
            //this._leadChangeTl.to( winnerRowBg, { alpha: 1, duration: 0.4, ease: "sine.out" } );
        }
        this._leadChangeTl.call( () => { 
            playerRowBg.visible = true;
            this._updatePlayerRowBg( arrFinalLeaderboardPlayerIndex.indexOf( this._playerIndex ), playerRowBg );

            for ( let button of arrButton )
            {
                button.setEnabled( true );
            }

            if ( this._round === 1 )
            {
                for ( let rankItem of arrRankItem )
                {
                    rankItem.visible = true;
                }
            }
        }, null );
        ServiceLocator.game.tweenGroup.add( this._leadChangeTl );

        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );
    }

        private _updatePlayerRowBg( playerRowIndex: number, playerRowBg: PIXI.Sprite ): void
        {
            const kPlayerRowBgTextureId: string = "results_" + ( this._isGameOver && playerRowIndex == 0 ? "final" : "round" ) + "_highlight_" + ( playerRowIndex == 0 ? "winner" : "row" );
            playerRowBg.texture = ServiceLocator.resources[ kPlayerRowBgTextureId ].texture;
            playerRowBg.y = [ 0, 175, 302, 429 ][ playerRowIndex ];
            if( playerRowBg.y > 0 && this._isGameOver )
            {
                playerRowBg.y += 21;
            }
        }

        private _addCrown( portrait: PIXI.Sprite ): PIXI.Sprite
        {
            let crown: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.crown.texture );
            crown.anchor.set( 0.5, 1 );
            crown.x = portrait.texture.width * 0.5;
            crown.y = -portrait.texture.height * 0.9;
            portrait.addChild( crown );

            return crown;
        }

        private onContinueBtn_Click(): void
        {
            if ( this._isGameOver )
            {
                this._root.interactiveChildren = false;

                let lobbyLayer: PIXI.Container = new PIXI.Container();
                this._root.addChildAt( lobbyLayer, 0 );

                let bg = new PIXI.Sprite( ServiceLocator.resources.bg.texture );
                bg.anchor.set( 0.5 );
                bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
                lobbyLayer.addChild( bg );
        
                let gameLogo: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.game_logo.texture );
                gameLogo.position.set( ServiceLocator.app.width * 0.5, 140 );
                gameLogo.anchor.set( 0.5, 0 );
                lobbyLayer.addChild( gameLogo );
        
                let profileAvatar: PIXI.Sprite = new PIXI.Sprite();
                profileAvatar.anchor.set( 0, 0.5 );
                GSAvatarLoader.i.load( 
                    Session.i.profile ? Session.i.profile.avatar.src : "avatar_you", 
                    ( texture: PIXI.Texture ) => {
                        try
                        {
                            profileAvatar.texture = texture;
                            profileAvatar.scale.set( 100/profileAvatar.texture.width ); 
                        }
                        catch( ex ) {}
                    } );
                profileAvatar.position.set( 16, 58 + 7.5 );
                lobbyLayer.addChild( profileAvatar );
        
                let profileTitle: PIXI.Text = new PIXI.Text( Session.i.profile ? Session.i.profile.username.prefix : "", { fontFamily: "asap_bold", fontSize: 40, fill: 0x474747, stroke: 0xffffff, strokeThickness: 6, lineJoin: "round" } );
                profileTitle.anchor.set( 0, 0.5 );
                profileTitle.position.set( profileAvatar.x + 120, 58 + 2 );
                lobbyLayer.addChild( profileTitle );
                //
                Utils.fitTextToWidth( profileTitle, 300 );
        
                let classicModeBtn: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.button_classic_mode_0.texture );
                classicModeBtn.scale.set( 0.97 );
                classicModeBtn.anchor.set( 345/805, 492/1028 );
                classicModeBtn.position.set( 305 * 0.5 + 4, 790 );
                lobbyLayer.addChild( classicModeBtn );
        
                let friendsModeBtn: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.button_friends_mode_0.texture );
                friendsModeBtn.scale.set( 0.97 );
                friendsModeBtn.anchor.set( 330/810, 490/1029 );
                friendsModeBtn.position.set( ServiceLocator.app.width - 305 * 0.5 - 8, classicModeBtn.y );
                lobbyLayer.addChild( friendsModeBtn );

                let settings: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.button_settings.texture );
                settings.anchor.set( 0.5 );
                lobbyLayer.addChild( settings );
                settings.position.set( ServiceLocator.app.width - 58, 58 );
                //
                const kSettingsScale: number = 100 / settings.width;
                settings.position.x -= 58 * ( kSettingsScale - 1 ); 
                settings.position.y += 58 * ( kSettingsScale - 1 ) - 4; 
                settings.scale.set( kSettingsScale );

                let banner: PIXI.Container = this._frontLayer.getChildByName( "banner" );
                let base: PIXI.Container = this._frontLayer.getChildByName( "base" );
                let homeBtn: PIXI.Container = this._frontLayer.getChildByName( "homeBtn" );
                let playBtn: PIXI.Container = this._frontLayer.getChildByName( "playBtn" );
                //
                let tl: gsap.core.Timeline = new gsap.core.Timeline();
                tl.to( banner, { y: -100 - ServiceLocator.app.safeAreaMarginY, duration: 0.8, ease: "back.in" }, 0 );
                tl.to( base, { x: ServiceLocator.app.width + ServiceLocator.app.safeAreaMarginX + base.width, duration: 0.8, ease: "back.in" }, 0.1 );
                tl.to( homeBtn, { y: ServiceLocator.app.height + ServiceLocator.app.safeAreaMarginY + homeBtn.height, duration: 0.8, ease: "back.in" }, 0.2 );
                tl.to( playBtn, { y: ServiceLocator.app.height + ServiceLocator.app.safeAreaMarginY + homeBtn.height, duration: 0.8, ease: "back.in" }, 0.3 );
                tl.to( this._backLayer, { alpha: 0, duration: 1.1, ease: "sine.in" }, 0 );
                tl.to( gameLogo, { y: gameLogo.y, duration: 0.8, ease: "back.out" }, 1.1 );
                tl.to( classicModeBtn, { x: classicModeBtn.x, duration: 0.8, ease: "back.out(1)" }, 1.2 );
                tl.to( settings.scale, { x: settings.scale.x, y: settings.scale.x, duration: 0.8, ease: "back.out" }, 1.3 );
                tl.to( friendsModeBtn, { x: friendsModeBtn.x, duration: 0.8, ease: "back.out(1)" }, 1.4 );
                tl.to( profileAvatar.scale, { x: profileAvatar.scale.x, y: profileAvatar.scale.x, duration: 0.8, ease: "back.out" }, 1.5 );
                tl.to( profileTitle.scale, { x: profileTitle.scale.x, y: profileTitle.scale.x, duration: 0.8, ease: "back.out" }, 1.5 );
                tl.call( () => { this._onClosed.dispatch( this, false ); } );

                gameLogo.y = -gameLogo.height - ServiceLocator.app.safeAreaMarginY;
                profileAvatar.scale.set( 0 );
                profileTitle.scale.set( 0 );
                settings.scale.set( 0 );
                classicModeBtn.x = -classicModeBtn.width - ServiceLocator.app.safeAreaMarginX;
                friendsModeBtn.x = ServiceLocator.app.width + ServiceLocator.app.safeAreaMarginX + friendsModeBtn.width;
            }
            else
            {
                this._onClosed.dispatch( this, false );
            }
        }

        private onPlayBtn_Click(): void
        {
            this._onClosed.dispatch( this, true );
        }

        private _onProfile_Changed( profile: Profile ): void
        {
            ( Session.i.profile.username as any ) = profile.username;
            ( Session.i.profile.avatar as any ) = profile.avatar;
            if ( Session.i.profile.isFake )
            {
                Session.i.profile.isFake = false;
            } 
        }

    public onLeave(): void
    {
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        if ( this._leadChangeTl )
        {
            this._leadChangeTl.kill();
            this._leadChangeTl = null;
        }

        if ( this._confettiAnim )
        {
            this._confettiAnim.end();
            this._confettiAnim = null;
        }

        super.onLeave();
    }

    public onUpdate( dt: number ): void 
    {
        if ( this._confettiAnim )
        {
            this._confettiAnim.update( dt );
        }
    }

    public disablePlayAgainBtn(): void
    {
        this._playBtn.setEnabled( false );
    }

    public onHostLeft(): void
    {
        this._playBtn.setEnabled( false );
    }

    // #endregion //
}